import { SxProps } from '@mui/material';
import { white } from 'app/components/ThemeProvider/colors';

export const mainBox: SxProps = {
  display: 'flex',
  height: 'fit-content',
  justifyContent: 'flex-end',
  mt: '100px',
  mb: '100px',

  '@media screen and (max-height: 864px)': {
    mt: '28px',
    mb: '28px',
  },

  '@media screen and (min-width: 320px) and (max-width: 767px)': {
    mt: '50px !important',
  },
};

export const loginFormBox: SxProps = {
  width: '525px',
  height: '643px',
  display: 'flex',
  flexDirection: 'column',
  background: white,
  padding: '42px 44px',
  borderRadius: '12px',

  '@media screen and (max-height: 864px)': {
    height: '600px',
  },

  '@media screen and (min-width: 320px) and (max-width: 767px)': {
    width: '100vw',
    padding: '0 0',
  },
};
